const DEFAULT_MAXIMUM_ALLOWANCE = 150
const DEFAULT_WINDOW_DAYS = 90
const DEFAULT_QUANTITIES = [30, 60, 90, 120, 150]

function toQuantity (value) {
  return parseInt(value, 10) || 0
}

export function normalizeStudentKitAllowance (allowanceData) {
  const studentKitsOrdered = toQuantity(allowanceData.studentKitsOrdered)
  const maximumAllowance = toQuantity(allowanceData.maximumAllowance) || DEFAULT_MAXIMUM_ALLOWANCE
  const returnedRemainingAllowance = parseInt(allowanceData.remainingAllowance, 10)
  const remainingAllowance = Number.isInteger(returnedRemainingAllowance)
    ? Math.max(0, returnedRemainingAllowance)
    : Math.max(0, maximumAllowance - studentKitsOrdered)
  const eligibilityWindow = allowanceData.eligibilityWindow || {}
  const orderingWindowDays = toQuantity(eligibilityWindow.days) || DEFAULT_WINDOW_DAYS
  const availableQuantities = Array.isArray(allowanceData.availableQuantities)
    ? allowanceData.availableQuantities
      .map(toQuantity)
      .filter(quantity => quantity > 0)
    : DEFAULT_QUANTITIES.filter(quantity => quantity <= remainingAllowance)
  const canOrder = typeof allowanceData.canOrder === 'boolean'
    ? allowanceData.canOrder
    : availableQuantities.length > 0

  return {
    studentKitsOrdered,
    maximumAllowance,
    remainingAllowance,
    availableQuantities,
    canOrder,
    orderingWindowDays,
    eligibilityWindow
  }
}

export function getStudentKitDisplayState ({
  orderingDisabled,
  inventoryQuantity,
  canOrder
}) {
  const inventoryUnavailable = orderingDisabled || toQuantity(inventoryQuantity) < 30

  return {
    showStudentKit: canOrder && !inventoryUnavailable,
    showInventoryPlaceholder: inventoryUnavailable,
    showAllowancePlaceholder: !inventoryUnavailable && !canOrder
  }
}

export function normalizePartialSubmission (partialSubmission) {
  return {
    submittedKitTypes: Array.isArray(partialSubmission.submittedKitTypes)
      ? partialSubmission.submittedKitTypes
      : [],
    submittedOrderCount: toQuantity(partialSubmission.submittedOrderCount),
    failedKitType: partialSubmission.failedKitType || '',
    retryAllowed: partialSubmission.retryAllowed === true,
    requiresAdministratorReview: partialSubmission.requiresAdministratorReview !== false
  }
}
